module.exports = __webpack_public_path__ + "static/img/mainbusiness01.e8c52ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/mainbusiness01.png
// module id = zEiZ
// module chunks = 1